import React from "react";
import Phone from "../../assets/phone.svg";
import Mail from "../../assets/mail.svg";
import Privacy from "../../assets/privacy.png";

function privacypolicy() {
  return (
    <div className="sectionbg">
      <div className="container mx-auto p-5 md:px-8 lg:px-20">
        <div className="pb-10 pt-5">
          <h1 className="font-bold text-center font-newblack text-[40px] leading-[48px] mb-3">
            Privacy Policy
          </h1>
          <p className="font-newblack text-xl text-center font-bold inter">
            Last Updated: 25 July 2024
          </p>
          <div className="flex justify-start items-center gap-10 pt-10 lg:flex">
            <img src={Privacy} alt="fbt-b2b" />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 my-10 lg:grid-cols-3 md:gap-10 md:my-24">
          <div className="col-span-2 order-last lg:order-none">
            <p className="text-2xl font-bold poppins font-newblack pt-2 md:pt-6 md:text-3xl">
              Privacy Summary
            </p>
            <div id="introduction">
              <p className="text-xl font-bold poppins font-newblack pt-2 md:pt-6 ">
                1. Introduction
              </p>
              <p className="pt-2 inter text-slate-500 font-medium text-md leading-[30px]">
                Welcome to FBTB2B travel portal ("Portal") operated by FBT Adventures Travels LLC ("FBT Adventures," "we," "us," or "our"). We value your privacy and are committed to
                protecting your personal information. This Privacy Policy
                explains how we collect, use, and disclose your information when
                you use our services.
              </p>
            </div>
            <div id="informationwecollect">
              <p className="text-xl font-bold poppins font-newblack pt-2 md:pt-6 ">
                2. Information We Collect
              </p>
              <p className="pt-2 inter text-slate-500 font-medium text-md leading-[30px]">
                We may collect and process the following information about you:
                <br />
                <span className="text-black font-semibold">
                  ·Personal Information:
                </span>{" "}
                Name, email address, phone number, and other contact details.{" "}
                <br />
                <span className="text-black font-semibold">
                  ·Device Information:
                </span>{" "}
                Information on how you interact with our website and services.{" "}
                <br />
                <span className="text-black font-semibold">
                  ·Cookies and Tracking Technologies:
                </span>{" "}
                Data collected through cookies, web beacons, and similar
                technologies.
                <br />{" "}
              </p>
            </div>
            <div id="yourinformation">
              <p className="text-xl font-bold poppins font-newblack pt-2 md:pt-6 ">
                3. How We Use Your Information
              </p>
              <p className="pt-2 inter text-slate-500 font-medium text-md leading-[30px]">
                We may use the information we collect for various purposes,
                including: <br />
                <ul className="list-disc text-black ml-5">
                   <li  className="text-slate-500">
                    To Provide and Improve Services: Ensuring you get the best
                    experience from our services.
                  </li>
                   <li  className="text-slate-500">
                    {" "}
                    To Communicate with You: Responding to your inquiries and
                    sending service-related notifications.
                  </li>
                   <li  className="text-slate-500">
                    For Marketing Purposes: Sending promotional materials that
                    may be of interest to you.
                  </li>
                   <li  className="text-slate-500"> To process transactions and bookings.</li>
                   <li  className="text-slate-500">
                    To Comply with Legal Obligations: Ensuring compliance with
                    legal requirements and regulations.
                  </li>
                </ul>
              </p>
            </div>
            <div id="disclosure">
              <p className="text-xl font-bold poppins font-newblack pt-2 md:pt-6 ">
                4. Disclosure of Your Information
              </p>
              <p className="pt-2 inter text-slate-500 font-medium text-md leading-[30px]">
                We may disclose your information to third parties under certain
                circumstances, such as: <br />
                <ul className="list-disc text-black ml-5">
                   <li  className="text-slate-500">
                  <span className="text-black font-semibold">With Service Providers:</span> Sharing information with third-party
                    vendors who assist us in providing our services.
                  </li>
                   <li  className="text-slate-500">
                  <span className="text-black font-semibold">For Legal Reasons:</span> Disclosing information if required by law
                    or to protect our rights.
                  </li>
                   <li  className="text-slate-500">
                  <span className="text-black font-semibold">With Your Consent:</span> Sharing your information in ways you have
                    consented to.
                  </li>
                </ul>
              </p>
            </div>
            <div id="security">
              <p className="text-xl font-bold poppins font-newblack pt-2 md:pt-6 ">
                5. Security of Your Information
              </p>
              <p className="pt-2 inter text-slate-500 font-medium text-md leading-[30px]">
                We implement security measures to protect your personal
                information from unauthorized access and use. However, no
                internet transmission is completely secure, and we cannot
                guarantee absolute security.
              </p>
            </div>
            <div id="rights">
              <p className="text-xl font-bold poppins font-newblack pt-2 md:pt-6 ">
                6. Your Rights
              </p>
              <p className="pt-2 inter text-slate-500 font-medium text-md leading-[30px]">
                <ul className="list-disc text-black ml-5">
                  <li className="text-slate-500">
                  <span className="text-black font-semibold">Access and Update:</span> You can access and update your personal
                    information at any time.
                  </li>
                   <li  className="text-slate-500">
                  <span className="text-black font-semibold">Opt-Out:</span> You can opt out of receiving marketing
                    communications from us.
                  </li>
                   <li  className="text-slate-500">
                  <span className="text-black font-semibold">Data Deletion:</span> You can request the deletion of your personal
                    information.
                  </li>
                </ul>
              </p>
            </div>
            <div id="changestoprivacypolicy">
              <p className="text-xl font-bold poppins font-newblack pt-2 md:pt-6 ">
                7. Changes to This Privacy Policy
              </p>
              <p className="pt-2 inter text-slate-500 font-medium text-md leading-[30px]">
                We may update this Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                our website.
              </p>
            </div>
            <div id="contactus" className="w-full md:w-3/4">
              <p className="text-xl font-bold font-newblack pt-2 md:pt-6 ">
                8. Contact us
              </p>
              <p className="pt-2 text-slate-500 font-medium text-md leading-[30px]">
                <span className="text-black font-bold">
                  FBT Adventures Travels LLC
                </span>
                <br />
                <span className="text-sm ">
                  Office No 400-70, 4th Floor Fahidi Height Office Tower, Sharaf
                  DG Metro Station gate No. 4 - Bur Dubai – Dubai, United Arab
                  Emirates
                </span>
                <span className="flex gap-2 my-1 text-black">
                  <img src={Mail} alt="Journeyx" />
                  <a href="mailto:care@fbt.ae" className="hover">
                    care@fbt.ae
                  </a>
                </span>
                <span className="flex gap-2 mb-1 text-black">
                  <img src={Phone} alt="Journeyx" />
                  <a href="tel:+971-43271179" className="hover">
                    +971-43271179
                  </a>
                </span>
              </p>
            </div>
          </div>
          <div>
            <p className="text-2xl font-bold poppins font-newblack py-2 md:pt-6 ">
              Table of Content:
            </p>
            <ul className="list-disc text-black ml-5">
              <a href="#introduction">
                <li className="underline mb-2 hover">1. Introduction</li>
              </a>
              <a href="#informationwecollect">
                <li className="underline mb-2 hover">
                  2. Information We Collect
                </li>
              </a>
              <a href="#yourinformation">
                <li className="underline mb-2 hover">
                  3. How We Use Your Information
                </li>
              </a>
              <a href="#disclosure">
                <li className="underline mb-2 hover">
                  4. Disclosure of Your Information
                </li>
              </a>
              <a href="#security">
                <li className="underline mb-2 hover">
                  5. Security of Your Information
                </li>
              </a>
              <a href="#yourchoices">
                <li className="underline mb-2 hover">6. Your Choices</li>
              </a>
              <a href="#changestoprivacypolicy">
                <li className="underline mb-2 hover">
                  7. Changes to This Privacy Policy
                </li>
              </a>
              <a href="#contactus">
                <li className="underline mb-2 hover">8. Contact Us</li>
              </a>
            </ul>
            <hr className="mt-10 h-0.5" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default privacypolicy;
